module.exports = function() {
  return new Worker(__webpack_public_path__ + "cd97c1034d543b90085d.worker.js");
};